// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TEJf","col":"styles_col__ML9kZ"};